import { BranchListType, BranchEditType } from '@/models/branchListModel'
import { PaginationStatus } from '@/models/paginationModel'
import { ApiResponseBranchList, ApiResponseBranchEditData } from '@/models/apiResponses/branches'

export class BranchManagementUtils {
  /**
   * APIレスポンスを教室一覧情報に変換する
   * @param apiResponse 教室一覧APIレスポンス
   * @returns 教室一覧情報
   */
  public static formatBranchDatas(apiResponse: ApiResponseBranchList): BranchListType[] {
    if (!apiResponse) return []

    return apiResponse.responses
  }

  /**
   * APIレスポンスからページネーションの状態を取得
   * @param apiResponse 教室一覧APIレスポンス
   * @returns ページネーション情報
   */
  public static getPagenationStatus(apiResponse: ApiResponseBranchList): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }

  /**
   * システム管理者権限画面で使用する教室編集情報を生成する
   * @param apiResponse 教室取得APIのレスポンス
   * @returns 教室編集情報
   */
  public static buildAdminBranchEditData(apiResponse?: ApiResponseBranchEditData): BranchEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        academyId: '',
        branchName: '',
        branchCode: '',
      }
    }

    return {
      id: apiResponse.id,
      // プルダウンのvalueとして受け渡すのでstring型にする
      academyId: String(apiResponse.academyId),
      branchName: apiResponse.branchName,
      branchCode: apiResponse.branchCode,
    }
  }

  /**
   * 塾管理者権限画面で使用する教室編集情報を生成する
   * @param apiResponse 教室取得APIのレスポンス
   * @returns 教室編集情報
   */
  public static buildAcademyBranchEditData(apiResponse?: ApiResponseBranchEditData): BranchEditType {
    // APIレスポンスが渡されない場合は新規登録用の情報をセット
    if (!apiResponse) {
      return {
        branchName: '',
        branchCode: '',
      }
    }

    return {
      id: apiResponse.id,
      branchName: apiResponse.branchName,
      branchCode: apiResponse.branchCode,
    }
  }
}
